// Seção "Nossos fones" reutilizada em várias páginas (home, serviços e soluções).
// Para trocar foto ou texto dos modelos, edite só este arquivo.
export default function NossosFones() {
  return (
    <section id="nossos-fones" className="py-16 scroll-mt-28 bg-gray-50 dark:bg-gray-800/50">
        <div className="max-w-7xl mx-auto px-6">
          <h2 className="font-heading font-bold text-3xl text-secondary dark:text-white text-center mb-3">Nossos fones</h2>
          <p className="font-body text-gray-600 dark:text-gray-300 text-center max-w-2xl mx-auto mb-10">Equipamento próprio, entregue, instalado e operado pela equipe da STIB. Mais de 5.000 fones disponíveis, bateria de 10 a 12 horas e até 10 canais simultâneos.</p>
          <div className="grid md:grid-cols-2 gap-6 max-w-5xl mx-auto">
            {[['/img/stib/fone-led-uhf.webp', 'Fone sem fio LED UHF', 'Anel de LED com cor personalizável que identifica o canal. O favorito para aulas, festas, feiras e grandes eventos.'],
              ['/img/stib/fone-vhf.jpg', 'Fone sem fio VHF', 'Visor de canal integrado e transmissão estável. Indicado para palestras, visitas técnicas e treinamentos.']].map(([src, nome, txt]) => (
              <div key={nome} className="bg-white dark:bg-gray-800 rounded-2xl overflow-hidden border border-gray-100 dark:border-gray-700">
                <img src={src} alt={nome} loading="lazy" className={`w-full aspect-[16/9] ${src.includes('vhf') ? 'object-contain object-center bg-white p-4' : 'object-cover'}`} />
                <div className="p-6">
                  <h3 className="font-heading font-bold text-secondary dark:text-white mb-2">{nome}</h3>
                  <p className="font-body text-sm text-gray-600 dark:text-gray-300">{txt}</p>
                </div>
              </div>
            ))}
          </div>
        </div>
      </section>
  );
}
